import { useState, useEffect } from 'react';
import {useSearchParams, Link, generatePath, createSearchParams, useNavigate} from "react-router-dom";
import {Card, Col, Steps, Typography, Collapse, Divider, Row, Select, Button, message, Spin} from "antd";
import { MyButton, MyText } from "../../components";
import { PageName, PlayButtonContainer, StyledUpload, ThemeCollapse, CustomCollapse, LessonPageWrapper, StepIconWrapper, StyledStep, VideoWrapper, LessonSteps, GoalText, ContentText, StyledButton } from './style';
import CardImg from '../../assets/images/pages/Main/game-1.webp';
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import { useEmbeddedNavigate } from '../../utils/context/embed';
import {fetchContentByCategoryAction, fetchGameCategoriesAction, fetchGamesListAction, ROUTE_PATH, selectStore} from "../../utils";
const isMobile = window.innerWidth < 768;

const { Option } = Select;

const { Step } = Steps;
const { Panel } = Collapse;


export const GamesChapter = ({ id }: { id: number }) => {
    const {t} = useTranslation("common")

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const embeddedNavigate = useEmbeddedNavigate();

    const [searchParams, setSearchParams] = useSearchParams();
    const [selectedSubThemeId, setSelectedSubThemeId] = useState(null);
    const [selectedSubThemeName, setSelectedSubThemeName] = useState(null);

    const themeParam = searchParams.get('theme');
    const idParams = searchParams.get('id');
    const segmentedParams = searchParams.get('type');
    const typeIdParams = searchParams.get('typeId');
    const parentIdParams = searchParams.get('parentId');
    const ageParams = searchParams.get('age');
    const contentByCategory = useSelector((state: any) => state.materials?.contentByCategory ?? { data: null, loading: false });

    const [isPlaying, setIsPlaying] = useState<boolean[]>([]);
    const [themes, setThemes] = useState([]);
    const [lessons, setLessons] = useState<any>([]);
    const [activeKeyTheme, setActiveKeyTheme] = useState(null);

    const colors = [
        {
            textColor: "#467BA2",
            borderColor: "#6DC1FD",
            backgroundColor: "rgba(109, 193, 253, 0.15)",
        },
        {
            textColor: "#428B56",
            borderColor: "#67D987",
            backgroundColor: "rgba(103, 217, 135, 0.15)",
        },
        {
            textColor: "#A07A1A",
            borderColor: "#FABF29",
            backgroundColor: "rgba(250, 191, 41, 0.15)",
        },
        {
            textColor: "#A35E2B",
            borderColor: "#FF9244",
            backgroundColor: "rgba(255, 146, 68, 0.15)",
        },
        {
            textColor: "#A33232",
            borderColor: "#FF4F4F",
            backgroundColor: "rgba(255, 79, 79, 0.15)",
        },
        {
            textColor: "#624192",
            borderColor: "#9865E3",
            backgroundColor: "rgba(152, 101, 227, 0.15)",
        },
    
    ]

    const {materials: {gameCategories: gameCategoriesState}} = useSelector(selectStore)

    useEffect(() => {
        dispatch(fetchGameCategoriesAction())
    }, []);

    useEffect(() => {
        if (lessons.length > 0) {
            setIsPlaying(Array(lessons.length).fill(false));
        }
    }, [lessons]);

    // useEffect(() => {
    //     const fetchContent = async () => {
    //         if (id) {
    //             try {
    //                 const response = await fetchContentByCategory(id);
    //                 const fetchedThemes = response.themes;
    //                 setThemes(fetchedThemes);
    
    //                 const firstType1Theme = fetchedThemes.find(theme => theme.type === 1);
                    
    //                 if (firstType1Theme) {
    //                     const responseLesson = await fetchContentByCategory(id, firstType1Theme.id);
    //                     setLessons(responseLesson.content);
    //                     setSelectedSubThemeName(firstType1Theme.name);
    //                     setSelectedSubThemeId(firstType1Theme.id);
    
    //                     const parentTheme = fetchedThemes.find(theme => theme.id === firstType1Theme.parent_id);
    //                     if (parentTheme) {
    //                         setActiveKeyTheme(parentTheme.id);
    //                     }
    //                 } else {
    //                     console.warn('No theme with type 1 found');
    //                 }
    //             } catch (error) {
    //                 console.error('Error fetching content:', error);
    //             }
    //         }
    //     };
    
    //     fetchContent();
    // }, [id]);
    useEffect(() => {
        if (id) dispatch(fetchContentByCategoryAction({ categoryId: id, loadFirstTheme: true }));
    }, [id]);

    useEffect(() => {
        if (!contentByCategory.success || !contentByCategory.data) return;
        const data = contentByCategory.data;
        setThemes(data.themes || []);
        if (data.firstTheme) {
            setLessons(data.firstThemeLessons || []);
            setSelectedSubThemeName(data.firstTheme.name);
            setSelectedSubThemeId(data.firstTheme.id);
            const parentTheme = data.themes.find(t => t.id === data.firstTheme.parent_id);
            if (parentTheme) setActiveKeyTheme(parentTheme.id);
        }
    }, [contentByCategory.success, contentByCategory.data]);

    // const parentThemes = themes.filter(theme => theme.type === 0 && theme.parent_id === 0);

    // const handleSelectGameCategory = (parentTheme: any) => {

    //     const path = {
    //         pathname: generatePath(ROUTE_PATH.MATERIALS_DETAIL, {parentTheme: parentTheme.id}),
    //         // @ts-ignore
    //         search: createSearchParams({
    //            age: ageParams,
    //            type: segmentedParams,
    //            parentId: parentIdParams,
    //            parentTheme: parentTheme.id,
    //            id: idParams,
    //            single: true
    //         }).toString(),
    //     }

    //     navigate(path)

    // }
    const parentThemes = themes.filter(theme => theme.type === 0 && theme.parent_id === 0);

const handleSelectGameCategory = (parentTheme: any) => {
  const searchParams: any = {
    age: ageParams,
    type: segmentedParams,
    parentId: parentIdParams,
    parentTheme: parentTheme.id,
    id: idParams,
  };

  // typeId нужен, чтобы после перехода остался выбранный таб,
  // а не первый с тем же scenary.
  if (typeIdParams) {
    searchParams.typeId = typeIdParams;
  }

  if (parentThemes.length === 1) {
    searchParams.single = true;
  }

  const path = {
    pathname: generatePath(ROUTE_PATH.MATERIALS_DETAIL, { parentTheme: parentTheme.id }),
    search: createSearchParams(searchParams).toString(),
  };

  embeddedNavigate(path);
};

    useEffect(() => {
        if (parentThemes.length === 1) {
            handleSelectGameCategory(parentThemes[0])
        }
    }, [parentThemes])


    return (
        <Col span={24}>
            <div style={{ display: 'flex', gap: '32px', justifyContent: 'space-between' }}>
                <Card style={{ width: isMobile ? '100%' : '100%', borderRadius: '20px' }}>
                {!isMobile && (
                <Col span={24}>
                            <MyText color='rgba(19, 15, 38, 1)' size={32} weight={800}
                                    style={{fontFamily: 'Nunito', display: 'block', marginBottom: 32}}>
                             {`${t("selectSection")}`}
                            </MyText>

                            </Col>

                            
                )}
                <LessonPageWrapper style={{padding: '0'}}>
                
                <Row  style={{ width: '100%' }} gutter={[16,16]}>
                {parentThemes.map((parentTheme, index) => (
                <Col
                    xs={24}
                    sm={12}
                    md={8}
                    lg={24}
                    xl={24}
                    xxl={24}
                >
                    <Card hoverable bordered={false} style={{
                    borderRadius: 24
                    }} styles={{
                    body: {
                        border: `1px solid ${colors[index].borderColor}`,
                        backgroundColor: colors[index].backgroundColor,
                        borderRadius: 24
                    }
                    }}
                    onClick={() => handleSelectGameCategory(parentTheme)}>
                    <Col>
                        <MyText style={{fontFamily: "Nunito"}} weight={500} size={22} lineHeight="32px">
                        {parentTheme.name}
                        </MyText>
                    </Col>
                    </Card>
                </Col>
                ))}                
                    </Row>
                </LessonPageWrapper>
                            </Card>
            </div>
        </Col>
    );
};
